var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.advert.image)?_c('img',{attrs:{"src":_vm.advert.image,"alt":""},on:{"click":function($event){return _vm.advertJump()}}}):_c('img',{attrs:{"src":_vm.defaultImg}})
}
var staticRenderFns = []

export { render, staticRenderFns }